import { render } from "./SiteSettings.vue?vue&type=template&id=ce0f2ed8"
import script from "./SiteSettings.vue?vue&type=script&lang=js"
export * from "./SiteSettings.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__